import { BaseAction } from "../../../../core/actions/BaseAction";
import { sendPasswordResetLink } from "../../../../app/api/changePassword";
import { showNotification } from "../../../../Services/notificationService";

interface ISendPasswordResetLinkParams {
    userId: string;
}

export class SendPasswordResetLinkAction extends BaseAction<void, ISendPasswordResetLinkParams> {
    override async run(): Promise<void | null> {
        try {
            const { userId } = this.params!;

            if (!userId) {
                console.error("User ID not found.");
                showNotification("error", "Error sending password reset link", "User ID is required");
                return;
            }

                        const response = await sendPasswordResetLink(userId);
            
            if (response.status !== "ok") {
                showNotification("error", "Failed to send password reset link", "Please try again later");
            }
            // Success is handled by the modal UI, so no success notification needed
        } catch (error) {
            console.error("Error in SendPasswordResetLinkAction:", error);
            showNotification("error", "Error sending password reset link", "An unexpected error occurred");
        }
    }
}

export const sendPasswordResetLinkAction = new SendPasswordResetLinkAction();